import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {wifiSearch, smallWifi} from '../../../../components/connectivity-guru/wifi-analyzer-scan/icons';
import {ArOutline} from '../../icons';
import {ITimelineItem} from './contract';
import {ScanImageBox} from '../scan-image-box/ScanImageBox';

export interface ITimelineItemProps {
    item: ITimelineItem;
    index: number;
    onItemClick: (index: number) => void;
    showLabelIcons?: boolean;
    showLine?: boolean;
}

@observer
export class TimelineItem extends TechseeBaseComponent<ITimelineItemProps> {
    renderInternal(): JSX.Element {
        const {item, index, onItemClick, showLabelIcons = false, showLine = false} = this.props;
        const selectedClass = item.isSelected ? ' selected' : '';
        const hasWifiData = item.signalStrengthPercentage || item.rssi;

        return (
            <React.Fragment>
                <div className={`timeline-item-container${selectedClass}`} onClick={() => onItemClick(index)}>
                    <div className={`timeline-item-background${selectedClass}${hasWifiData ? ' wifi-scan' : ''}`}>
                        {item.imageUrl && <ScanImageBox imageUrl={item.imageUrl} className='timeline-image' />}
                        {item.signalStrengthPercentage && (
                            <div
                                className={'signal-strength-percentage-container'}
                                style={{color: item.signalStrengthPercentage.color}}>
                                <div className={'icon'}>{smallWifi}</div>
                                <p>{item.signalStrengthPercentage.value}%</p>
                            </div>
                        )}

                        {item.rssi && <p className={'rssi'}>{item.rssi}dBm</p>}

                        <div className={'scans-count-container'}>
                            {(item.wifiScanCount ?? 0) > 0 && (
                                <div className={'scans-count-container-info'}>
                                    <div className={'icon'}>{wifiSearch}</div>
                                    <p>{item.wifiScanCount}</p>
                                </div>
                            )}
                            {(item.visualScanCount ?? 0) > 0 && (
                                <div className={'scans-count-container-info'}>
                                    <div className={'icon'}>{ArOutline}</div>
                                    <p>{item.visualScanCount}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={`timeline-item-main${showLabelIcons ? ' with-icons' : ''}`}>
                        {showLabelIcons && (
                            <div className={`icon ${hasWifiData ? 'wifi-scan-icon' : 'visual-scan-icon'}`}>
                                {hasWifiData ? wifiSearch : ArOutline}
                            </div>
                        )}
                        <div className={'timeline-item-info'}>
                            <p className={'timeline-item-text'}>{item.type}</p>
                            <p className={'timeline-item-date'}>{item.time}</p>
                        </div>
                    </div>
                </div>
                {showLine && <div className={'timeline-line'} />}
            </React.Fragment>
        );
    }
}
